<template>
    <div class="service-form">
        <div class="service-document" >

            <div class="form" >
                <div class="form-client">
                    <div class="separator">
                        {{ $t('dados-auditoria') }}
                    </div>
                    <div class="columns is-100 is-multiline is-mobile client-info is-gapless mb-0">
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('colaborador') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.usuario ? data.usuario.nome : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('login') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.login }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('acao') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.acao ? data.acao : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('datahora') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.datahora ? $moment(data.datahora).format('L') : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('ip') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.remoteip ? data.remoteip : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('appversion') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.appversion ? data.appversion : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('plataforma') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.platform ? data.platform : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('versao') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.vendor ? data.vendor : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-full info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('useragent') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.useragent ? data.useragent : '—' }} </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div> 

            </div>
        </div>
    </div>
</template>
<script>
import AuditoriaService from '@/services/AuditoriaService';
import { palette as paleta } from "@/functions/color/Palette";

export default {
    data() {
        return {
            data: { },
            primary_color: this.$store.state.partnerSystemHasLayout.primary_color,
            secondary_color: paleta.getChartColors()[paleta.getChartColors().length-1],
            tertiaryColor: paleta.getChartColors()[3]
        };
    },
    props: {
        idauditlogin: 0
    },
    created () {
        this.service = new AuditoriaService(this.$http, this.$router);
        this.loadData(this.idauditlogin);
    },
    methods: {
        loadData( idauditlogin ){
            this.$store.commit('addLoader');
            this.service.findAuditLoginById( idauditlogin ).then( res =>{
                this.data = res.content;     
                switch(this.data.loginok){
                    case 0:
                        this.data.acao = "LOGIN_FALHA";
                        break;
                    case 1:
                        this.data.acao = "LOGIN_SUCESSO";
                        break;
                    case 2:
                        this.data.acao = "LOGOUT";
                        break;
                    default:
                        break;
                }
                // console.log(this.data);
            })
            .catch(e => {
                this.$root.showMessage('error', 'msg-erro-relatorio');
            })
            .finally(_ => {
                this.$store.commit('removeLoader');
            });
        },
    },
};

</script>
<style lang="scss" scoped>

.with-spacer{
    margin-right: 0.5rem !important;
}
.service-form{

    .service-document{
        background: $sovis-white;
        height: 100%;
        padding: 20px;

        .enterprise-logo, .client-logo {
            .logo{
                height: auto;
                max-height: 80px;
            }
        }  
        .enterprise-info {
            h2{
                text-align: center;
                font-size: 18px;
                font-weight: 600;
            }
            h3{
                text-align: center;
                font-size: 12px;
            }
        }  
        .report-title {
            font-size: 20px;
            margin-bottom: 10px;
            
            h1{
                font-weight: 600;
            }
        }

        .form{
            width: 100%;

            .form-client{
                width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                margin-bottom: 20px;

                .separator{
                    width: 100%;
                    border-top: 1px solid $table-border;
                    border-bottom: 1px solid $table-border;
                    padding: 10px 0;
                    text-align: center;
                    margin-bottom: 10px;
                    font-weight: 600;
                    font-size: 18px;
                }

                .separator.dual-column{
                    display: flex;
                    justify-content: space-between;

                    .after, .before{
                        width: 50%;
                    }
                }

                .client-info{
                    .description{
                        font-weight: 600;
                        // font-size: 16px;
                        margin-bottom: 0px;
                    }
                    .capitalize{
                        text-transform: capitalize;
                    }
                    .info{
                        margin-bottom: 0.5rem;
                    }
                }

                .data-block-alt{
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;

                    .client-info{
                        width: 20%;
                    }
                }

                .data-block-form{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    
                    .client-info{
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;

                        h4, p{
                            width: 20%;
                        }
                    }
                }

                .img-wrapper{
                    
                    padding: 10px;
                    height: max-content;

                    img{
                        width: 100%;
                        height: 200px;
                        object-fit: contain;
                    }

                    .legend, .opt-obs{
                        font-size: 12px;
                        display: flex;
                        justify-content: space-between;
                        margin-top: 5px;

                        p{
                            width: 100%;
                            text-align: center;
                            text-transform: uppercase;
                        }
                        .icon-location{
                            width: 25%;
                            text-align: right;
                            .svg-icons{
                                width: 30px;
                                height: 30px;
                            }
                        }

                        .opt-text {
                            display: flex;
                            flex-wrap: wrap;

                            p{
                                width: 100%;
                            }
                        }
                            
                        
                    }            

                    &.share, &.pesquisa{
                        .client-info{
                            h4, p{
                                width: 10%;
                                &.bigger{
                                    width: 60%;
                                }
                            }
                        }
                    }
                }

                .map-photo{
                    text-align: center;
                    width: 100%;
                    margin-top: 10px;
                
                    img{
                        border: 1px solid $table-border;
                        max-width: 100%;
                    }

                    .map-legend{
                        display: flex;

                        .map-legend-container {

                            .legend-item{
                                text-align: left;
                                margin-left: 30px;
                                margin-right: 30px;
                            }                    
                        }
                    }
                }
            }
            
            .assinatura{
                margin-top: 80px;
                margin-right: 20px;
                width: 300px;
                height: 300px;

                .opt-img {
                    border-bottom: 1px solid $table-border;
                    width: 300px;
                    height: 250px;

                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .opt-legend, .opt-obs{
                    font-size: 12px;
                    display: flex;
                    justify-content: space-between;
                    margin-top: 5px;

                    p{
                        width: 100%;
                    }
                }
            }
        }
    }
}

</style>